import { useState } from 'react';
import {App} from './App';
import splash from './cross-word-splash.jpg';
import {gdSdk} from './gd-sdk';
import {Loading} from './Loading';

export const AppContainer = ()=>{

    const startPlayDefault = window.location.host === 'html5.gamedistribution.com';

    //console.log('window.location.host',window.location.host,window.location,startPlayDefault);

    const [startPlay,setStartPlay] = useState(startPlayDefault);
    const [showSpinner,setShowSpinner] = useState(false);

    const onStartGameClick = async()=>{

        const onGamePause =()=>{
            setShowSpinner(false);
        };

        const onGameStart = ()=>{
            //console.log('hiding spinner');
            setShowSpinner(false);
        };

        const onAddError = ()=>{
            setShowSpinner(false);
            setStartPlay(true);
        };


        try{
            
            setShowSpinner(true);

            gdSdk.onceAdError(onAddError);
            gdSdk.onceGameStart(onGameStart);
            gdSdk.onceGamePause(onGamePause);           
                     
            await gdSdk.showAdCore(true);
            //console.log('Puzzle show ad success!!!');
            
            
        }
        catch(e){
            console.log('Puzzle error on showing ad',e);
        }finally{
            gdSdk.removeAdErrorListener(onAddError);
            gdSdk.removeGamePauseListener(onGamePause);
            gdSdk.removeGameStartListener(onGameStart);
        }

        setStartPlay(true);
        
    };
    const gameStart = (
        <>        
        {showSpinner? <Loading/> : null}
        <div className="game-start">
            <div className="splash-header">Cross Word Puzzles</div>
            <div>
                <img  className='splash-image' src={splash} alt="cross word puzzles"></img>
            </div>            
            <div className="game-start-button" onClick={onStartGameClick}>Play</div>
        </div>
        </>
    );

    return startPlay ? <App></App> : gameStart;
};